import $ from 'jquery';

class UnauthorizedController {
  constructor() {
    "ngInject";
  }

}

export default UnauthorizedController;



// WEBPACK FOOTER //
// ./client/pages/403/unauthorized.controller.js